const FUNCTIONS_URL = "https://europe-west1-maison-chateaux-d-eau.cloudfunctions.net";
const HA_PROXY_URL = `${FUNCTIONS_URL}/haProxy`;
const LIVRET_API_URL = `${FUNCTIONS_URL}/livretApi`;

// Appelle une Cloud Function protégée (haProxy, livretApi).
// - sejourToken fourni : accès client (vérifié côté serveur avec les dates du séjour)
// - sinon : accès admin avec la session Firebase en cours
async function functionRequest(url, payload, sejourToken) {
  const headers = { "Content-Type": "application/json" };
  if (!sejourToken) {
    // Chargé à la demande : la page visiteur n'embarque pas Firebase Auth
    const { auth } = await import("./auth");
    const idToken = await auth.currentUser?.getIdToken();
    if (!idToken) throw new Error("Non connecté");
    headers.Authorization = `Bearer ${idToken}`;
  }

  const res = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify({ ...payload, sejourToken }),
  });
  const result = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(result.error || `Erreur ${res.status}`);
    err.code = result.error;
    throw err;
  }
  return result;
}

export const fetchHaStates = (sejourToken) => functionRequest(HA_PROXY_URL, { action: "states" }, sejourToken);

export const callHaService = (domain, service, data, sejourToken) =>
  functionRequest(HA_PROXY_URL, { action: "service", domain, service, data }, sejourToken);

// Livret d'accueil : Wi-Fi et transports
export const fetchLivret = (action, sejourToken) => functionRequest(LIVRET_API_URL, { action }, sejourToken);
